import ResponsiveWrapper from 'components/shared/others/responsive-wrapper/responsive-wrapper';
import React from 'react';

const HeroLearnPartial = (): React.JSX.Element => (
  <div className="flex justify-center md:flex-row bg-navy-800 mobile:h-[300px] xs:logo-bg xs:bg-[150%] md:bg-right">
    <ResponsiveWrapper customClass="flex flex-col justify-center">
      <div className="tablet:w-[600px]">
        <h1 className="text-5xl font-semibold text-white mb-4">
          MARKETview Learning Hub
        </h1>
      </div>
    </ResponsiveWrapper>
  </div>
);

export default HeroLearnPartial;
